module.exports = __webpack_public_path__ + "img/dissatisfied.509dbe9.svg";